<template>
  <section class="empresas-asociadas">
    <h2 class="section-title">Agentes Autorizados</h2>

    <div class="associated-companies">
      <a
        v-for="(company, index) in associatedCompanies"
        :key="index"
        :href="company.link"
        class="company-card"
        :target="isExternal(company.link) ? '_blank' : '_self'"
        :rel="isExternal(company.link) ? 'noopener noreferrer' : null"
        @mouseover="hovered = index"
        @mouseleave="hovered = null"
        :class="{ 'hovered': hovered === index }"
      >
        <div class="card-inner">
          <div class="card-front">
            <img
              v-if="company.icon"
              :src="require(`@/assets/Img/Logo_Navar/${company.icon}`)"
              :alt="company.name"
              class="company-logo"
            />
            <font-awesome-icon
              v-else-if="company.faIcon"
              :icon="company.faIcon"
              class="company-fa-icon"
            />
            <span class="company-name">{{ company.name }}</span>
          </div>
          <div class="card-back">
            <p>Visita {{ company.name }} para más información</p>
          </div>
        </div>
      </a>
    </div>
  </section>
</template>

<script>
export default {
  name: 'EmpresasAsociadas',
  data() {
    return {
      hovered: null,
      associatedCompanies: [
        {
          name: 'Cashea',
          link: 'https://www.cashea.app/',
          icon: 'unnamed.jpg'
        },
        {
          name: 'Inter',
          link: 'https://inter.com.ve/',
          icon: 'InterVE-Logo.png'
        },
        {
          name: 'Kaosnet',
          link: 'https://www.kasnet.com/',
          icon: 'logoempresa.jpeg'
        }
      ]
    }
  },
  methods: {
    isExternal(link) {
      return link.startsWith('http')
    }
  }
}
</script>

<style scoped>
.empresas-asociadas {
  padding: 3rem 1rem;
  background: linear-gradient(135deg, #f0f4ff, #e0e8ff);
  position: relative;
  overflow: hidden;
}

.section-title {
  font-size: 2.2rem;
  font-weight: 700;
  margin-bottom: 2rem;
  text-align: center;
  color: #222;
}

.associated-companies {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 2rem;
}

.company-card {
  width: 160px;
  height: 180px;
  perspective: 1000px;
  text-decoration: none;
}

.card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  transition: transform 0.6s ease;
  transform-style: preserve-3d;
}

.company-card.hovered .card-inner {
  transform: rotateY(180deg);
}

.card-front,
.card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  transition: box-shadow 0.3s ease;
}

.card-front:hover {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
}

.card-back {
  transform: rotateY(180deg);
  font-size: 0.9rem;
  color: #444;
  text-align: center;
}

.company-logo {
  width: 70px;
  height: auto;
  margin-bottom: 0.5rem;
}

.company-fa-icon {
  font-size: 2.5rem;
  margin-bottom: 0.5rem;
  color: #555;
}

.company-name {
  font-size: 1rem;
  font-weight: 600;
  color: #333;
}
</style>
